<h4>Details</h4>
<form>
    <div class="row">
        <div class="col-md-6">
            <app-bx-input-textbox
                [(ngModel)]="recipient.name"
                name="recipient-name"
                [bxInputTextOptions]="{
                    maxLength: 300,
                    label: 'Supplier Name',
                    locked: false,
                    status: 'none',
                    required: false,
                }">
            </app-bx-input-textbox>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <app-bx-input-textbox
                [(ngModel)]="recipient.email"
                name="recipient-email"
                [bxInputTextOptions]="{
                    maxLength: 50,
                    label: 'Email',
                    locked: false,
                    status: 'none',
                    required: false,
                }">
            </app-bx-input-textbox>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <label>Phone</label>
            <phone-number
                ngDefaultControl
                [(ngModel)]="recipient.mobile"
                name="rfq-response-mobile"
                [number]="recipient.mobile"
                [bxInputTextOptions]="{
                    maxlength: 50,
                    label: 'Mobile',
                    locked: false,
                    status: 'none',
                    required: false,
                }">
            </phone-number>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <label>Notes</label>
            <textarea
                legacy-css
                class="form-control form-control-v2"
                type="text"
                placeholder="Notes will be added here"
                rows="5"
                [(ngModel)]="recipient.responseText"
                name="rfq-response-text"></textarea>
        </div>
    </div>
</form>
